import { BadgeProps } from '@pankod/refine-antd'

import { LMS_ORIGIN } from '@resources/lms-management/types'

export enum PROGRAM_LOCAL_STATE {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  DONE = 'done',
}

export const PROGRAM_LOCAL_STATES = [
  PROGRAM_LOCAL_STATE.DRAFT,
  PROGRAM_LOCAL_STATE.PUBLISHED,
  PROGRAM_LOCAL_STATE.DONE,
]

export const PROGRAM_LOCAL_BADGE_COLOR: Record<
  PROGRAM_LOCAL_STATE,
  BadgeProps['status']
> = {
  [PROGRAM_LOCAL_STATE.DRAFT]: 'warning',
  [PROGRAM_LOCAL_STATE.PUBLISHED]: 'processing',
  [PROGRAM_LOCAL_STATE.DONE]: 'error',
}

export const PROGRAM_LOCAL_STATE_LABEL = {
  [PROGRAM_LOCAL_STATE.DRAFT]: 'Persiapan',
  [PROGRAM_LOCAL_STATE.PUBLISHED]: 'Berjalan',
  [PROGRAM_LOCAL_STATE.DONE]: 'Selesai',
}

export type TLMSProgramLocal = {
  name: string
  id: number
  slug: string
  entity: {
    name: string
    id: number
  }
  status: PROGRAM_LOCAL_STATE
  programId: number
  provinsiId?: string
  kotaKabId?: string
  kecamatanId?: string
  provinsi?: string
  kotaKab?: string
  kecamatan?: string
  startDate?: string
  endDate?: string
  origin?: LMS_ORIGIN
}

export type TLMSProgramLocalRequest = Omit<
  TLMSProgramLocal,
  'id' | 'slug' | 'entity' | 'program' | 'provinsi' | 'kecamatan' | 'kotaKab'
> & {
  entityId: number
}

export type TimespendList = {
  id: string
  name: string
  email: string
  phone: string
  kelas: Kelas
  duration: {
    async: number
    sync: number
  }
}

export type TimespendPaymentStatus =
  | 'PAYMENT_STATUS_NOT_PAID'
  | 'PAYMENT_STATUS_PAID'
export type TimespendEligibleStatus =
  | 'ELIGIBLE_STATUS_ELIGIBLE'
  | 'ELIGIBLE_STATUS_NOT_ELIGIBLE'

export type SyncRecording = {
  id: string
  url: string
  title: string
  duration: number
}

type Kelas = {
  id: string
  name: string
}

export type PeriodePenilaian = {
  id: string
  name: string
  asyncTargetDuration: number
  syncTargetDuration: number
}

export type PaymentProof = {
  id: string
  imageUrl: string
  amount: string
  paymentDate: string
  notes?: string
  paymentStatus: TimespendPaymentStatus
  eligibleStatus: TimespendEligibleStatus
}

export type Timespend = {
  periode: (TimespendDetail &
    PeriodePenilaian & { paymentProof: PaymentProof })[]
  info: {
    fasilitatorName: string
    kelasName: string
    targetDuration: {
      async: number
      sync: number
    }
  }
}

export type TimespendDetail = {
  async: {
    id: string
    name: string
    duration: number
  }[]
  sync: {
    id: string
    name: string
    recordings: SyncRecording[]
  }[]
}
